module.exports = __webpack_public_path__ + "img/钱包.c4fe68a2.svg";